import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import BoxSearch from '../components/Layout/BoxSearch'
import ButtonStrip from '../components/Layout/ButtonStrip'
import ModalCreate from '../components/Parametros/ModalCreate'
import ModalDelete from '../components/Parametros/ModalDelete'

import {
    getParametros,
	toggleSelectItem,
	toggleSelectAllItems,
	filterParametros,
	setOrderBy,
	displayModalCreate,
	showHideModalDelete,
	deleteParametros
} from '../actions/parametros'

export const tableCols = [
    { id: 1, caption: 'Nombre', value: 'nombre', type: 'string', format: '', width: '15%', linkToEdit: true },
    { id: 2, caption: 'Descripción', value: 'descripcion', type: 'string', format: '', width: '70%' },
    { id: 3, caption: 'Categoría', value: 'categoria', type: 'string', format: '', width: '15%' },
]

export function findValues(c, x) {
	let value = x.getIn(c.value.split('.'))
	return value
}

class Parametros extends Component {
    componentWillMount() {
        this.props.getParametros()
    }

	render() {
        const { parametros, orderBy } = this.props

        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de parámetros', 'create') } title="Nuevo parámetro"/>,
            <BoxButton key="ba[1]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Parametros seleccionados?`, () => this.props.deleteParametros()) } disabled={ parametros.filter(x => x.get('selected')).count() === 0 } danger title="Eliminar parámetro" />,
        ]

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Parametros" stretch>
                        <ButtonStrip actions={ boxActions } />
                        <BoxSearch onChange={ this.props.filterParametros } />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-parametros">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(e.target.checked) } checked={ parametros.filter(x => x.get('selected')).count() > 0 && parametros.filter(x => x.get('selected') && x.get('visible')).count() >= parametros.filter(x => x.get('visible')).count() } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        parametros.filter(x => x.get('visible')).count() > 0 ? parametros.map(x => {
                                            if (!x.get('visible')) return null
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectItem(x.get('id'), e.target.checked) } checked={ x.get('selected') } />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        value = value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.linkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => this.props.displayModalCreate(true, 'Modificación de parametros', 'edit', x.get('id')) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
				<ModalCreate />
				<ModalDelete />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        parametros: state.parametros.get('parametros'),
        orderBy: state.parametros.get('orderBy'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getParametros: () => dispatch(getParametros()),
		toggleSelectItem: (id, checked) => dispatch(toggleSelectItem(id, checked)),
		toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
		filterParametros: (term) => dispatch(filterParametros(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		displayModalCreate: (show, title, mode, id) => dispatch(displayModalCreate(show, title, mode, id)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deleteParametros: () => dispatch(deleteParametros()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Parametros)


// WEBPACK FOOTER //
// ./src/containers/Parametros.jsx